export var FS_CONFIG;
(function (FS_CONFIG) {
    FS_CONFIG["FEATURE_FLAGS"] = "fs_feature_flags";
})(FS_CONFIG || (FS_CONFIG = {}));
